import { render } from "./WebEditor.vue?vue&type=template&id=a9a4fc2a&scoped=true"
import script from "./WebEditor.vue?vue&type=script&lang=js"
export * from "./WebEditor.vue?vue&type=script&lang=js"

import "./WebEditor.vue?vue&type=style&index=0&id=a9a4fc2a&scoped=true&lang=css"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a4fc2a"]])

export default __exports__